module.exports = __webpack_public_path__ + "static/img/ic_sale_regist@2x.7f1bfd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_sale_regist@2x.png
// module id = rUvZ
// module chunks = 1